var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormikIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "34.7mm",
    viewBox: "0 0 34.7 34.7",
    width: "34.7mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.0001948.00485276h34.699667v34.699667h-34.699667z",
    strokeWidth: 0.1187196918
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "matrix(.400018502 0 0 .400018502 5.34987738 .55385626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.869 0 9.694 5.5746-38.176 21.954-9.694-5.5747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.954 6.7451-37.936 21.806-.0013 11.032 37.936-21.806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.698 28.276-22.601 12.991-.0012 11.033 22.601-12.991z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.035 45.717-13.99 8.0421-.0013 11.033 13.991-8.0421z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.0037583 23.017 9.751 5.6047-.00375 11.035-9.751-5.6046z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.096543 35.657 9.6327 5.5367-.00376 11.035-9.6327-5.5366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.092298 48.221 9.6359 5.5386-.00401 11.763-9.6359-5.5386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.564 84-9.694-5.5746 37.743-21.704 9.6939 5.5746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.102 77.471 37.879-21.773.0012-11.032-37.879 21.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 55.974 22.601-12.991.0013-11.033-22.601 12.991z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.964 38.532 13.99-8.0421.0012-11.033-13.99 8.0421z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.996 61.306-9.7509-5.6046.0037-11.035 9.751 5.6046z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.904 48.595-9.6327-5.5367.0037-11.035 9.6327 5.5366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.908 36.031-9.636-5.5386.0039-11.552 9.636 5.5385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormikIcon);
export default __webpack_public_path__ + "static/media/formikIcon.44491957cb27c0d599af31a15433d212.svg";
export { ForwardRef as ReactComponent };